import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = {
  class: "card shadow p-4",
  style: {"margin-top":"-30px"}
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"row my-12\"><div class=\"col-sm-12 col-md-4 col-lg-3\"><a href=\"/acreditation/184/manager/home\" class=\"card mb-8 shadow text-black text-hover-primary border border-2 border-primary border-hover\"><div class=\"card-header p-0 overflow-auto w-100\" style=\"height:192px;\"><div class=\"d-flex z-index-1 position-absolute top-0 end-0 p-4\"></div><div class=\"el-image w-100 h-100\"><img src=\"https://www.perufedup.com/wp-content/uploads/2023/11/FEDUP-JURS-SUR-2023.png\" class=\"el-image__inner\" style=\"object-fit:contain;\"></div></div><div class=\"card-body p-5\"><div class=\"d-flex mb-4\" style=\"margin-top:-30px;\"><span class=\"badge badge-light-info z-index-1\"><i class=\"bi bi-people-fill me-2 text-info\"></i>Disponible</span></div><h2 class=\"title mb-4 fs-5 text-hover-primary text-center\">13° FEDUP Juegos Universitarios Regionales Sur 2023</h2><ul class=\"list-unstyled\"><li class=\"mb-2\"><i class=\"bi bi-geo-alt-fill me-3\"></i>Ciudad de Arequipa.</li><li class=\"mb-2\"><i class=\"far fa-calendar-alt me-3\"></i> <span>26 nov.<span> al 02 dic. 2023</span></span></li></ul></div></a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sHeader = _resolveComponent("sHeader")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_sHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.textSearch,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.textSearch) = $event)),
              class: "",
              size: "large",
              placeholder: "Buscar aquí"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _hoisted_5
    ])
  ], 64))
}